/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tq.js                                                                                */
/**********************************************************************************************************************/
/* Controller.TQ */

HafasWebapp.prototype.Controller.TQ = {
  currentTrainroute: null,
  currentResult: null,
  index: function() {
    // leer
  },
  showResult: function(data) {
    if (data.ev) {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }
    Hafas.ps.pub('/GUI/form/hide', []);
    Hafas.bind(this.Controller.TQ.showTrainroute, this)({data: data, additionalContext: 'TQ' });
  },
  hideResult: function(){
    var me = this;
    //Hafas('#TQ_Result').style.display = 'none';
    if(typeof me.Controller.TQ.currentTrainroute != 'undefined' && me.Controller.TQ.currentTrainroute != null){
      me.Controller.TQ.currentTrainroute.hide();
      me.Controller.TQ.currentTrainroute = null;
      me.Controller.TQ.currentResult = null;
    }
  },
  selectStation: function(data) {

    if((this.Controller.TQ.currentResult != null) && (this.Controller.TQ.currentResult.stopL[data.locIndex] != undefined))
    {
      var loc = this.Controller.TQ.currentResult.stopL[data.locIndex].locResolved;
      switch(Hafas.Config.TQ.selectLocationAction) {
        case "MoveMap":
          Hafas.ps.pub('/map/centerToGeo/webapp',[{coord:Hafas.Util.geo.hciCrdToHafasCoord(loc.crd)}]);
          break;
        case "SwitchToSQ":
          Hafas.ps.pub('/sq/searchFromOtherContext', [{location:{name:loc.name, lid:loc.lid}}, "info"]);
          Hafas.bind(this.Controller.TQ.hideResult, this)();
          break;
      }
    }
  },

  /**
   * @method hideAllTrainRoutes();
   * @public
   */
  hideAllTrainRoutes: function(data) {
    var _coll = Hafas('#HFS_SQOverviewResults .hfs_itemResults .hfs_tqInnerResultWrap', true);
    _coll.forEach(function(itm, idx) {
      if (itm.className.match(/js_tqResultOpened/g)) {
        itm.style.display = "none";
        itm.removeClassName('js_tqResultOpened');
      }
    });
  },

  /**
   * @method showTrainroute();
   * @public
   */
  showTrainroute: function(opts) {
    var me = this;
    var data = opts.data;

    if(Hafas.Modules.History) {
      Hafas.Modules.History.addData("TQ", "result", opts);
    }

    // show loader to prevent doubleclicks on label
    var $trigger = opts.data.trigger,
      _triggerHeight = $trigger.offsetHeight,
      _triggerInner = $trigger.innerHTML;

    if ($trigger.nodeName) {
      $trigger.style.height = _triggerHeight + 'px';
      $trigger.innerHTML = '<div class="hfs_spinner"></div>';
    }

    // Targetcontainer wird nur benoetigt, wenn der Zuglauf innerhalb des Stationboards angezeigt werden soll
    if (me.appContext === 'SQ' && (typeof Hafas.Config.showTQResultsInSQOverview != 'undefined' && Hafas.Config.showTQResultsInSQOverview == true)) {
      var $target = Hafas('[data-jid="' + data.jid + '"] .hfs_tqInnerResultWrap', false);


      var tqInnerResult = {
        show: function() {
          $target.setAttribute('aria-hidden', false);
          $target.removeAttribute('hidden');
        },
        hide: function() {
          $target.setAttribute('aria-hidden', true);
          $target.setAttribute('hidden', 'hidden');
        }
      };
      tqInnerResult.show();
    }

    var params = {
      jid: data.jid,
      callback: function(model) {

        model.startIdx = 0;
        model.endIdx = model.stopL.length;
        if ($trigger.nodeName) {
          model.trigger = $trigger;
          model.triggerInner = _triggerInner;
        }

        /*if (Hafas.Config.TP.showFullTQResult !== true) {
          model.startIdx = data.fIdX;
          model.endIdx = data.tIdX;
        }*/

        model.openedFromContext = opts.data.openedFromContext;

        model.viewHeader = {
          title: Hafas.Modules.i18n.get('TQ.index.t_N_applicationName')
        };

        if (typeof opts.data.independent != 'undefined') {
          model.independent = opts.data.independent;
        } else {
          model.independent = false;
        }

        // iterate through stopL to identifiy previous colors
        var _BG = model.prodResolved.icoResolved.bg;
        var _FG = model.prodResolved.icoResolved.fg;
        model.stopL.forEach(function(stop, idx) {
          stop.locResolved.icoResolved.BgResolved = _BG;
          stop.locResolved.icoResolved.FgResolved = _FG;
        });

        if (me.appContext === 'SQ' && (typeof Hafas.Config.showTQResultsInSQOverview != 'undefined' && Hafas.Config.showTQResultsInSQOverview == true)) {

          if ($target.className.match(/js_resultRendered/g)) {

            // toggeln der Ansicht, bei bereits abgeholten Ergebnissen
            if ($target.className.match(/js_tqResultOpened/g)) {
              $target.style.display = "none";
              $target.removeClassName('js_tqResultOpened');
              me.Controller.TQ.currentTrainroute.hide();
            }
            else {
              // schliesse zuerst alle geoeffnete Zuglaeufe
              Hafas.ps.pub('/GUI/tq/hideAllTrainRoutes', [{me: me}]);
              $target.style.display = "block";
              $target.addClassName('js_tqResultOpened');
            }
          }
          else {
            Hafas.Modules.Render.render(
              {
                file: 'tq.result.html',
                template: 'TQ_AtomTplResultWrap',
                model: model
              },
              function(response) {
                if ($trigger) {
                  $trigger.removeAttribute('style');
                  $trigger.innerHTML = _triggerInner;
                }
                Hafas.ps.pub('/GUI/tq/hideAllTrainRoutes', [{me: me}]);
                $target.innerHTML = response;
                $target.addClassName('js_resultRendered');
                $target.addClassName('js_tqResultOpened');
              }
            );
          }
          me.Controller.TQ.currentResult = model;
        }
        else {
          Hafas.ps.pub('/app/switchContext', [{context:"TQ"}]);
          Hafas.bind(me.Controller.TQ.renderResultView, me)(model);
        }

        // Tracking
        Hafas.ps.pub('/tracking/screen/journey-details', [ { typ: 'screen', key: 'journey-details' } ]);
        Hafas.ps.pub('/tracking/screen/route-details', [ { typ: 'screen', key: 'route-details' } ]);

        // Ergebnisse weiterleiten, werden von Timetable gebraucht /mroe
        Hafas.ps.pub('/trainroute/results', [model]);
      }
    };

    if (typeof data.fIdX != "undefined") {
      params.fIdX = data.fIdX;
    }
    if (typeof data.tIdX != "undefined") {
      params.tIdX = data.tIdX;
    }

    if (typeof me.Controller.Map != 'undefined' && typeof me.Controller.Map.instance != 'undefined') {
      params.map = me.Controller.Map.instance;
    }

    if (typeof me.Controller.TQ.currentTrainroute != 'undefined' && me.Controller.TQ.currentTrainroute != null) {
      me.Controller.TQ.currentTrainroute.hide();
    }
    me.Controller.TQ.currentTrainroute = Hafas.Core.newType("hafasTrainroute", params);
  },
  centerTrainroute: function () {
    var me = this;
    window.setTimeout(function(){
      if(me.appContext === 'TQ'){
        try {
          me.Controller.TQ.currentTrainroute.map.centerToContent(me.Controller.TQ.currentTrainroute.mapContent.centerPoly);
        }
        catch(e){}
      }
    },500);
  },
  renderResultView: function(model) {
    var me = this;
    this.Controller.TQ.currentResult = model;

    Hafas.Modules.Render.render(
      {
        file: 'tq.result.html',
        target: 'TQ_Result',
        template: 'TQ_AtomTplResult',
        model: model
      },
      function() {
        // show the additional container
         if(typeof model.trigger != 'undefined'){
           if (model.trigger) {
             model.trigger.innerHTML = model.triggerInner;
           }
         }

        Hafas.ps.pub('/GUI/results/overview/show', [{}]);

         // verkehrstagekalender?
        if(Hafas.Config.TQ.serviceDays.showAsCalendar && (typeof model.sDaysL !== 'undefined')){
          model.sDaysL.forEach(function(sDays,idx){
            // bitfolge vorhanden?
            if(typeof sDays.sDaysB !== 'undefined'){

              var sDTPConfig = {
                holder: 'HFS_TPServiceDaysCalendar_'+idx,
                id: 'TQServiceDays_'+idx,
                config: {
                  useDepArrSwitch: false,
                  useTimePicker: false,
                  useNowMode: false,
                  isModal: false,
                  showFullscreenInMobile: false,
                  readOnly: true,
                  markedDays: sDays.sDaysB
                }
              };

              Hafas.Core.newType('hafasTimeDatePicker', sDTPConfig);
            }

           });
         }

        // Todo: Trainroute auf der Karte anzeigen
        Hafas.ps.pub('/app/events/resize', [{keepOverviewScrollPos: true, keepDetailsScrollPos: true}]);
        Hafas.ps.pub('/app/events/resize', [{container: me.additionalContainer, appcontext: me.appContext, keepOverviewScrollPos: true, keepDetailsScrollPos: true, method: '/tq/showTrainroute'}]);
        // Nach ganz oben scrollen, wenn Zuglauf geöffnet wird
        Hafas.Util.gui.resetScrollTop();
      }
    );
  },
  closeView: function(histData) {
    switch (histData.view) {
      case "result":
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }

  },
  restoreView: function(histData) {
    var view = histData.view;
    switch(view) {
      case "result":
        Hafas.bind(this.Controller.TQ.showTrainroute, this)(histData.data);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderJourneyDetails'}]);
        break;
    }
    // PageContent muss wieder eingeblendet werden, da er zuvor im GUI Controller ausgeblendet wird
    if (this.layoutClass == "small") {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_PageContent"), true);
    }

  },
  cleanup: function () {
    Hafas.bind(this.Controller.TQ.hideResult, this)();
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/livemap/clearJourneyFilter',[true,true]);
  }
};